import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPortalNewLink]',
  standalone: false,
})
export class PortalNewLinkDirective {
  @HostListener('click')
  onClick(): void {
    window.open('https://techspert.com/release-hub', '_blank');
  }
}
